/**
 * Rybbit analytics identity.
 *
 * The tracking script is loaded from public/index.html and defines
 * `window.rybbit` asynchronously, so every call here degrades to a no-op
 * until it is ready rather than throwing on a cold start.
 */
import { StoredUserInfo, mapUserToRybbit } from "./userMapper";

declare global {
  interface Window {
    rybbit?: {
      identify: (userId: string, traits?: Record<string, unknown>) => void;
      clearUserId: () => void;
    };
  }
}

export function identifyRybbit(userInfo: StoredUserInfo | null): void {
  const mapped = mapUserToRybbit(userInfo);
  if (!mapped) return;
  window.rybbit?.identify(mapped.userId, mapped.traits);
}

/**
 * The identity lives in localStorage, so without this the next person to use
 * the browser inherits the previous user's identity.
 */
export function clearRybbit(): void {
  window.rybbit?.clearUserId();
}
